import { TrueArtisLogo } from '@/components/brand/TrueArtisLogo';

type AppBrandMarkProps = {
  variant?: 'light' | 'dark';
  compact?: boolean;
  className?: string;
};

/** Fixed TRUE ARTIS mark for sidebar header and top app bar. */
export function AppBrandMark({ variant = 'light', compact = false, className }: AppBrandMarkProps) {
  return (
    <TrueArtisLogo
      variant={variant}
      showTagline={!compact}
      className={className ?? (compact ? 'max-w-[198px]' : 'max-w-[240px]')}
    />
  );
}
